import React from "react";

export default class Translate extends React.Component {
  render() {
    return <div id="google_translate_element" />;
  }
}



// WEBPACK FOOTER //
// ./src/Common/Translation.js